import React from 'react';
import I18n from 'i18n-js';
import { ChildProps } from 'react-apollo';
import gql from 'graphql-tag';

import ListingSidebarCSPCard from './listing_sidebar_csp_card';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { CoreListingCspCard } from '../../../schemas/rql';

export interface IProps {
  cspId: string;
}

export class ListingSidebarCSP extends React.Component<ChildProps<IProps, CoreListingCspCard.Query>, null> {
  render() {
    if (!this.props.data.loading && !this.props.data.csp) return null;

    return (
      <div>
        <h4 className="weight-bold mb-half">
          {I18n.t('discovery.comparisonShoppingPages.listingSidebar.findMore')}
        </h4>
        <ListingSidebarCSPCard
          csp={this.props.data.csp}
        />
      </div>
    );
  }
}

const connect = withGraphql<IProps, CoreListingCspCard.Query>(
  gql`
    query Core_Listing_CspCard(
      $id: String
    ){
      csp(input: { id: $id }) {
        _id
        id
        title
        reviews {
          total
          avgRating
        }
        webLink {
          href
        }
        image(input: { transform:"large"}) {
          source
        }
        inventory {
          newLowPrice {
            amountCents
            display
          }
          usedLowPrice {
            amountCents
            display
          }
        }
      }
    }
  `,
  {
    options: ownProps => ({
      ssr: false, // not important for SEO or initial page rendering
      variables: {
        id: ownProps.cspId,
      },
    }),
  },
);

export default connect(ListingSidebarCSP);
